// extracted by mini-css-extract-plugin
module.exports = {"card":"card--9fff0","meta":"meta--cb84d","themeName":"themeName--b4362","placeholder":"placeholder--59316"};